import React from 'react'
 export default function ListFilled() {
 return (
 <>
 <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill="black" d="M8 18C8 17.4477 8.44772 17 9 17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H9C8.44772 19 8 18.5523 8 18Z" clipRule="evenodd" fillRule="evenodd"></path>
<path fill="black" d="M8 12C8 11.4477 8.44772 11 9 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H9C8.44772 13 8 12.5523 8 12Z" clipRule="evenodd" fillRule="evenodd"></path>
<path fill="black" d="M8 6C8 5.44772 8.44772 5 9 5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H9C8.44772 7 8 6.55228 8 6Z" clipRule="evenodd" fillRule="evenodd"></path>
<path fill="black" d="M3 16C2.44772 16 2 16.4477 2 17V19C2 19.5523 2.44772 20 3 20H5C5.55228 20 6 19.5523 6 19V17C6 16.4477 5.55228 16 5 16H3Z" clipRule="evenodd" fillRule="evenodd"></path>
<path fill="black" d="M3 10C2.44772 10 2 10.4477 2 11V13C2 13.5523 2.44772 14 3 14H5C5.55228 14 6 13.5523 6 13V11C6 10.4477 5.55228 10 5 10H3Z" clipRule="evenodd" fillRule="evenodd"></path>
<path fill="black" d="M3 4C2.44772 4 2 4.44772 2 5V7C2 7.55228 2.44772 8 3 8H5C5.55228 8 6 7.55228 6 7V5C6 4.44772 5.55228 4 5 4H3Z" clipRule="evenodd" fillRule="evenodd"></path>
</svg>
</>
)}

/*
IF YOU WANT A SQUARE

<svg width="24" height="24" viewBox="2.4 5.1 5 0.01" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill="black" d="M4 3C3.44772 3 3 3.44772 3 4V6C3 6.55228 3.44772 7 4 7H6C6.55228 7 7 6.55228 7 6V4C7 3.44772 6.55228 3 6 3H4Z" clipRule="evenodd" fillRule="evenodd"></path>
</svg>
*/